module.exports = __webpack_public_path__ + "img/zixun5.98fbbc28.png";